import * as React from 'react';
import * as styles from './email_tooltip.css';

import { TooltipPopup } from '../../tooltip_popup';

interface IEmailTooltipProps {
  isTooltipOpen: boolean;
  handleTooltipIconClick(): void;
  handleTooltipePopupClose(): void;
}

export function EmailTooltip(props: IEmailTooltipProps) {
  const {isTooltipOpen, handleTooltipIconClick, handleTooltipePopupClose} = props;

  return(
    <div className={styles['label']}>
      <span className={styles['label-text']}>Ваш email</span>
      <div className={styles['tooltip-container']}>
        <div className={styles['tooltip-icon']} onClick={handleTooltipIconClick}/>
        <TooltipPopup
          open={isTooltipOpen}
          handlePopupClose={handleTooltipePopupClose}
          containerClass={styles['tooltip']}
          direction="left"
        >
          {/* tslint:disable-next-line:no-irregular-whitespace */}
          Для получения уведомлений  о новых объявлениях
        </TooltipPopup>
      </div>
    </div>
  );
}
